import {ImageSourcePropType, Linking} from 'react-native';

export type BannerVariant = 'promotional' | 'feature' | 'info' | 'campaign';

export interface DynamicBannerConfig {
  id: string;
  variant: BannerVariant;

  // campaign specific (rich event banners — e.g. Daily Arena, Puzzle Royale —
  // rendered entirely by their own component; see CampaignBanner.tsx)
  render?: () => JSX.Element;

  // common
  title?: string;
  buttonText?: string;
  onPress?: () => void;
  mainImage?: ImageSourcePropType;
  mainImageMobile?: ImageSourcePropType;
  backgroundColor?: string;
  tags?: string[];
  tagsMobile?: string[];

  // promotional specific (e.g. BrightChamps)
  logo?: ImageSourcePropType;
  offerText?: string;
  couponCode?: string;
  onCopyCoupon?: () => void;

  // feature specific (e.g. Masterclass)
  subTitle?: string;
  checkmarks?: string[];
  priceText?: string;

  // info specific (persona-driven real-data slides: review/assessment/
  // leaderboard/class reminders — see BannerCarousel's bannerSets)
  kicker?: string;
  icon?: ImageSourcePropType;
  live?: boolean;
}

export const DASHBOARD_BANNERS: DynamicBannerConfig[] = [
  // {
  //   id: 'masterclass_opening',
  //   variant: 'feature',
  //   logo: require('@/Assets/Images/png/circle_chess_logo.png'),
  //   subTitle: 'Play to Win series',
  //   title: 'Master Your Chess Opening Today',
  //   checkmarks: [
  //     'Special Opening Tournaments',
  //     'Personalised Opening Assessment',
  //     // 'GM MasterClass on Opening',
  //   ],
  //   tags: ['Sicilian Najdorf', 'Italian', 'London'],
  //   tagsMobile: [],
  //   priceText: 'Starting 8th May',
  //   buttonText: 'Free entry - Join Now',
  //   mainImage: require('@/Assets/Images/gukesh_banner_img.png'),
  //   mainImageMobile: require('@/Assets/Images/gukesh_banner_mobile.png'),
  //   backgroundColor: '#1E293B',
  //   onPress: () => {
  //     Linking.openURL('https://learn.circlechess.com/playChess?tournamentId=3746').catch(err =>
  //       console.error('Failed to open URL:', err),
  //     );
  //   },
  // },
  // {
  //   id: 'brightchamps',
  //   variant: 'promotional',
  //   logo: require('@/Assets/Images/Svgs/BeginnerDashboard/BrightChampsLogo.svg'),
  //   title: 'BrightCHAMPS for CircleChess Families',
  //   tags: ['Coding', 'Gen AI', 'Robotics', 'Math', 'Free Trial Class'],
  //   tagsMobile: ['Coding', 'Gen AI', 'Robotics', 'Math'],
  //   offerText: 'UP TO 25% OFF',
  //   couponCode: 'CIRCLECHESS25',
  //   buttonText: 'Book Free Trial',
  //   mainImage: require('@/Assets/Images/Svgs/BeginnerDashboard/GirlMathIcon.svg'),
  //   mainImageMobile: require('@/Assets/Images/Svgs/BeginnerDashboard/GirlMathIconMobile.svg'),
  //   onPress: () => {
  //     Linking.openURL('https://link.brightchamps.com/Fck1R5DufFyQe').catch(
  //       err => console.error('Failed to open URL:', err),
  //     );
  //   },
  // },
];
